// extracted by mini-css-extract-plugin
module.exports = {"pagination":"F-pagination-pagination-2DuvM","pageSize":"F-pagination-page-size-3q4eZ","loading":"F-pagination-loading-28TVz","hidden":"F-pagination-hidden-G25IZ"};